"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.history = void 0;

var _react = require("react");

var _history = require("history");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line import/no-mutable-exports
let history;
exports.history = history;

try {
  exports.history = history = (0, _history.createBrowserHistory)();
} catch (e) {
  exports.history = history = null;
}

class Router extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "state", void 0);

    _defineProperty(this, "props", void 0);

    _defineProperty(this, "_parse", pathname => pathname.split('/').pop().split('.')[0] || 'index');

    _defineProperty(this, "_unlisten", void 0);

    this.state = {
      path: history ? this._parse(history.location.pathname) : props.path
    };
  }

  componentDidMount() {
    this._unlisten = history.listen(location => this.setState({
      path: this._parse(location.pathname)
    }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.path !== this.state.path) {
      const route = this.props.routes.find(r => r.link === this.state.path);

      if (route) {
        document.title = route.title || '';
      }
    }
  }

  componentWillUnmount() {
    this._unlisten();
  }

  render() {
    const route = this.props.routes.find(r => r.link === this.state.path);

    if (route) {
      return route.render(_objectSpread({}, route.props, {
        path: this.state.path
      }));
    }

    return null;
  }

}

exports.default = Router;
//# sourceMappingURL=Router.js.map